import { Injectable } from '@angular/core';
import {MatDialog, MatDialogConfig, MatDialogRef} from '@angular/material/dialog';
import {ConfirmComponent} from '../dialog/confirm-dialog/confirm.component';
import {Observable} from 'rxjs/Observable';
import {ProcedureSelectionDialogComponent} from '../dialog/procedure-selection-dialog/procedure-selection-dialog.component';
import {ProcedureSelectionDialogModel} from '../dialog/procedure-selection-dialog/models/procedure-selection-dialog.model';
import {TdoUserConfigurationModel} from '../models/configuration/user/tdo-user-configuration.model';
import {PatientCheckinDialogComponent} from '../dialog/patient-checkin-dialog/patient-checkin-dialog.component';
import {Appointment} from '../landing/models';
import {TdoToothSelectorDialogComponent} from '../dialog/tdo-tooth-selector-dialog/tdo-tooth-selector-dialog.component';
import {ToothPickerConfigModel} from '../modules/tdo-shared/tooth-picker/tooth-picker-config.model';
import {ToothConfigurationModel} from '../models/teeth/tooth-configuration.model';
import {ToothPickerComponent} from '../modules/tdo-shared/tooth-picker/tooth-picker.component';
import {MedicalHistoryDialogComponent} from '../dialog/medical-history-dialog/medical-history-dialog.component';
import {PainHistoryDialogComponent} from '../dialog/pain-history-dialog/pain-history-dialog.component';
import {InternalMessagingDialogComponent} from '../dialog/notifications/internal-messaging-dialog/internal-messaging-dialog.component';
import {NotificationDestinationDataModel} from '../models/messaging/notification-destination-data.model';
import {NotificationCreateDialogComponent} from '../dialog/notifications/notification-create-dialog/notification-create-dialog.component';
import {TaskManagementDialogComponent} from '../dialog/tasks/task-management-dialog/task-management-dialog.component';
import {ConfirmExplanationDialogComponent} from '../dialog/confirm-explanation-dialog/confirm-explanation-dialog.component';
import {TdoIconPickerComponent} from '../tdo-controls/common/tdo-icon-picker/tdo-icon-picker.component'


@Injectable({
    providedIn: 'root'
})
export class DialogService {
    confirmDialogRef: MatDialogRef<any>;
    data: any;
    constructor(private dialog: MatDialog) {

    }

    setData(data: any) {
        this.data = data;
    }

    clearData(){
        this.data = undefined;
    }

    getData(): any {
        return this.data;
    }

    openConfirmDialogExplanation(message: string, isShowNo: boolean = false, isShowCancel: boolean = true, title: string = '', explanation: string = ''): Observable<any> {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = {message, isShowNo, isShowCancel, title, explanation};
        const dialogRef = this.dialog.open(ConfirmExplanationDialogComponent, config);
        this.confirmDialogRef = dialogRef;
        return dialogRef.afterClosed();
    }

    openConfirmDialog(message: string, isShowNo: boolean = false, isShowCancel: boolean = true, title: string = ''): Observable<any> {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = {message, isShowNo, isShowCancel, title};
        const dialogRef = this.dialog.open(ConfirmComponent, config);
        this.confirmDialogRef = dialogRef;
        return dialogRef.afterClosed();
    }

    openProcedureDialog(model: ProcedureSelectionDialogModel = null): Observable<any> {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        if (model) {
            config.data = model;
        }
        const dialogRef = this.dialog.open(ProcedureSelectionDialogComponent, config);
        return dialogRef.afterClosed();
    }

    openPatientCheckInDialog(appt: Appointment) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        if (appt) {
            config.data = appt;
        }
        const dialogRef = this.dialog.open(PatientCheckinDialogComponent, config);
        return dialogRef.afterClosed();
    }

    openToothSelector(patientId: string) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = {patientId};
        return this.dialog.open(TdoToothSelectorDialogComponent, config).afterClosed();
    }

    openToothPicker(isMultiTooth: boolean) {
        const toothConfig = new ToothPickerConfigModel();
        toothConfig.isMultiSelect = isMultiTooth;
        const teeeth: ToothConfigurationModel[] = [];
        /* const currentTeeth = this.returnTeethForCurrentSelectedItem();
    for (const tt of currentTeeth) {
      const toot = new ToothConfigurationModel();
      toot.ToothId = tt.ToothId;
      teeeth.push(toot);
    }
    toothConfig.selectedTeeth = teeeth;*/

        // open a window to add a new procedure form to this case
        return this.dialog.open(ToothPickerComponent, {
            panelClass: 'dialog',
            data: toothConfig
        }).afterClosed();
    }

    openMedicalHistory(patientId: string) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = {patientId};
        return this.dialog.open(MedicalHistoryDialogComponent, config).afterClosed();
    }

    openPainHistory(patientId: string) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = {patientId};
        return this.dialog.open(PainHistoryDialogComponent, config).afterClosed();
    }

    openInternalMessaging() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        return this.dialog.open(InternalMessagingDialogComponent, config).afterClosed();
    }

    openInstantMessaging(destination: NotificationDestinationDataModel) {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.data = destination;
        this.dialog.open(NotificationCreateDialogComponent, config);
    }

    openTasks() {
        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        this.dialog.open(TaskManagementDialogComponent, config);
    }


    openIconPicker()  {

        const config = new MatDialogConfig();
        config.panelClass = 'dialog';
        config.width="1000px";
        config.height="500px";
        return this.dialog.open(TdoIconPickerComponent, config).afterClosed();



    }




}
